export default "__VITE_ASSET__fee97923__"